// import React,{Component} from "react";
// import {
//   Col,
//   Progress,
//   FormGroup,
//   Label,
//   Input,
//   Button
// } from "reactstrap";
// import { base, s3base } from "api.js";
// import Sound from 'react-sound';
// import "components/custom.css";
// import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns";
// import SelectVoiceDropDown from "components/PracticeMaterial/SelectVoiceDropDown.jsx";

// class Dictation extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       isRecording: false,
//       blobURL: '',
//       isBlocked: false,
//       question:"",
//       secondCount:10,
//       recordCount:0,
//       recordId:1,
//       intervalId:0,
//       questionId:"",
//       reset:false,
//       soundStatus:true,
//       content:'',
//       soundPer:0,
//       volume:100,
//       correctFlag:true,
//       resultObj:{},
//       playbackSpeed: 1,
//       soundKey: 0,
//       question_audio: null,
//       defaultSelectedVoice: null,
//       playStatus: Sound.status.STOPPED
//     };
//   }

//   componentDidMount() {
//     if (!this.props.answer) {
      
//       // select audio.
//       let question_audio = null;
//       let defaultSelectedVoice = null;
//       if ('question_audios' in this.props.data && this.props.data.question_audios.length > 0) {
//         let x = parseInt(Math.random() * 6);

//         const { question_audios } = this.props.data;
//         question_audio = `${s3base}/${question_audios[x].value}`;
//         defaultSelectedVoice = question_audios[x].label;
//       } else {
//         const { media_link } = this.props.data;
//         question_audio = `${s3base}${media_link}`;
//       }

//       var intervalId = setInterval(this.timer, 1000);
//       this.setState({
//         intervalId,
//         question_audio,
//         defaultSelectedVoice
//       });
//     }

//   	// var intervalId = setInterval(this.timer, 1000);
//     // this.setState({intervalId: intervalId});
//   }

//   stopTest = () =>{
//     this.props.nextQuestion(this.state.resultObj);
//   }

//   static getDerivedStateFromProps(props, state) {
//   	if (props.data) {
//   		if ((state.questionId && state.questionId !== props.data.id) || props.restart) {
//   			clearInterval(state.intervalId);
//   			clearInterval(state.recordId);

//         let question_audio = null;
//         let defaultSelectedVoice = null;
//         if ('question_audios' in props.data && props.data.question_audios.length > 0) {
//           let x = parseInt(Math.random() * 6);

//           const { question_audios } = props.data;
//           question_audio = `${s3base}/${question_audios[x].value}`;
//           defaultSelectedVoice = question_audios[x].label;
//         } else {
//           const { media_link } = props.data;
//           question_audio = `${s3base}${media_link}`;
//         }

//   			return {
//           correctFlag: true,
//           recordCount: 0,
//           soundPer: 0,
//           isRecording: false,
//           secondCount: 10,
//           questionId: props.data.id,
//           blobURL: '',
//           reset: true,
//           soundStatus: true,
//           content: '',
//           question_audio,
//           defaultSelectedVoice
//         };
//   		} else {
//   			if (!state.questionId) {
//   				return {
//             correctFlag: true,
//             questionId: props.data.id
//           };
//   			}
//   		}
//   	}
//   }


// 	timer = () => {
// 		if (this.state.secondCount === 1) {
// 			clearInterval(this.state.intervalId);

//       this.setState({
//         playStatus: Sound.status.PLAYING,
//         secondCount: 0
//       });
// 		} else {
//   		this.setState({
//         secondCount: (this.state.secondCount - 1)
//       });
//     }
// 	}

//   handleSongPlaying = (obj) => {
//     this.setState({soundPer:obj.position*100/obj.duration});
//   }

//   changeRange = (e) => {
//     this.setState({
//       volume: parseInt(e.target.value)
//     });
//   }

//   handleSongFinishedPlaying = () => {
//     console.log("stopped.");
//     this.setState({
//       soundStatus: false,
//       playStatus: Sound.status.STOPPED
//     });
//     this.props.soundChecked();
//     this.props.showResult();
//   }

//   copyToClipboard = () => {
//     document.execCommand("copy");
//   };

//   cutToClipboard = () => {
//     document.execCommand("cut");
//   };

//   pasteToClipboard = async () => {
//     alert("Press Ctrl+v for paste text");

//   };

//   changePlaybackSpeed = (speed) => {
//     // this.setState((prevState) => ({
//     //   soundKey: prevState.soundKey + 1
//     // }));
//     // this.setState({playbackSpeed: speed});

//     this.setState((prevState) => ({
//       soundKey: prevState.soundKey + 1,
//       playbackSpeed: speed
//     }));
//   }

//   chaneText = (e) =>{
//     let { name, value } = e.target;
//     this.props.submit({'answer':value,'correct':''},true);
//     this.setState({ [name] : value, resultObj: {'answer':value,'correct':''} });
//   };

//   updateCorrect = () =>{
//     this.props.submit({'answer':'','correct':''});
//     this.setState({correctFlag:false,resultObj: {'answer':'','correct':''}});
//   }

// 	timerRecord = () => {
// 		if (this.state.recordCount === 40) {
// 			clearInterval(this.state.recordId);
// 			this.stop();
// 		}
// 		this.setState({ recordCount: this.state.recordCount + 1 });
// 	}

//   skip = () => {
//     clearInterval(this.state.intervalId);
//     this.setState({
//       secondCount: 0,
//       playStatus: Sound.status.PLAYING
//     });
//   };

// 	componentWillUnmount = () => {
// 		clearInterval(this.state.intervalId);
// 	}

//   changeAudio = (selected) => {

//     const { question_audios } = this.props.data;
//     const selected_audio = question_audios.filter((audio, i) => {
//       return audio.label === selected.label;
//     });

//     this.setState({
//       question_audio: `${s3base}/${selected_audio[0].value}`,
//       playStatus: Sound.status.PLAYING
//     });
//   }

//   onLoad = (obj) => {
//     // console.log(obj)
//   }

//   render() {
//   	let question ="";
//     if (this.props.restart) {
//       this.props.restartQue();
//     }
//     if (this.props.stopRecording) {
//       this.stopTest();
//     }
//   	if (this.props.data) {
//   		question = this.props.data.question;
//       if (this.state.correctFlag) {
//         this.updateCorrect();
//       }
//   	}
//   	if (this.state.reset) {
//   		var intervalId = setInterval(this.timer, 1000);
// 		  this.setState({intervalId: intervalId,reset:false});
//   	}

//     return (
//       <>
//         <Col xs={12}>
//         	<h4 className="infoText"></h4>
//           {this.props.data && !this.props.resultMode && this.state.soundStatus && this.state.secondCount === 0 &&
//             <Sound
//               autoLoad={true}
//               url={this.state.question_audio}
//               // url={s3base + this.props.data.media_link}
//               playStatus={this.state.playStatus}
//               onPlaying={this.handleSongPlaying}
//               volume={this.state.volume}
//               onFinishedPlaying={this.handleSongFinishedPlaying}
//               playbackRate={this.state.playbackSpeed}
//               key={this.state.soundKey}
//               onLoading={this.onLoad}
//             />
//           }
//         </Col>

//         {!this.props.resultMode && 
//           <Col xs={12}>
//           	<div className="col-lg-12 text-center">
//         		  <div className="currentStatus">
//                 <div>Current Status:{this.state.soundStatus == true && this.state.secondCount !== 0 && !this.state.isRecording && ' Begining in '+this.state.secondCount+ ' seconds' }
//                   {this.state.secondCount == 0 && this.state.soundStatus && ' Playing' }
//                   <br></br>
                  
//                   Volume
//                   <Input
//                     placeholder="Volume"
//                     type="range"
//                     defaultValue={this.state.volume}
//                     step={1}
//                     onInput={(e) => this.changeRange(e)}
//                     min={0}
//                     max={100}
//                   />
//                   <br></br>
                
//                   <Progress color="info" value={(this.state.soundPer)} />
//                   {!this.props.testMode && (
//                     <div className="d-flex justify-content-between">
//                       <div className='stop-btn'>
//                         {
//                           this.state.secondCount !== 0 &&
//                           this.state.blobURL === '' &&
//                           !this.state.isRecording &&
//                             <Button color="success" onClick={this.skip} size="sm">Skip</Button>
//                         }
//                       </div>

//                       <div className="stop-btn clearfix">
//                         <div className="select-voice pull-left">
//                           {this.state.defaultSelectedVoice !== null &&
//                             <SelectVoiceDropDown
//                               voices={this.props.voices}
//                               selected={this.state.defaultSelectedVoice}
//                               changeAudio={this.changeAudio}
//                             />
//                           }
//                         </div>
//                         <div className="select-speed pull-right">
//                           <PlaybackSpeedBtns
//                             changePlaybackSpeed={this.changePlaybackSpeed}
//                             playbackSpeed={this.state.playbackSpeed}
//                           />
//                         </div>
//                       </div>

//                     </div>
//                   )}
//                 </div>
//               </div>

//               <Col xs={12}></Col>
        		  
//               <Col xs={12}>
//         		  	{this.state.blobURL &&
//                   <audio
//                     src={this.state.blobURL}
//                     controls="controls"
//                   />
//                 }
//         		  </Col>
//         		</div>
//           </Col>
//         }

//         <Col xs={12}><h5>{question}</h5></Col>
        
//         {!this.props.resultMode &&
//           <Col xs={12}>
//             <FormGroup>
//               <Input
//                 type="textarea"
//                 name="content"
//                 autoCorrect="false"
//                 spellCheck="false"
//                 id="textBox"
//                 onChange={(e) => { this.chaneText(e)}}
//                 value={this.state.content}
//               />
//             </FormGroup>
//             <div className="bottomContent">
//               <p className="wordCount">Total word count: {this.state.content.split(' ').filter(function(n) { return n != '' }).length}</p>
//               <div className="copyPaste">
//                 <a href="javascript:void(0)" onClick={this.cutToClipboard} className="btn">Cut</a>
//                 <a href="javascript:void(0)" onClick={this.copyToClipboard} className="btn">Copy</a>
//                 <a href="javascript:void(0)" onClick={this.pasteToClipboard} className="btn">Paste</a>
//               </div>
//             </div>
//           </Col>
//         }
        
//         <Col xs={12}>
//           <h5>{this.props.data && this.props.answer &&  this.props.data.audio_script }</h5>
//         </Col>
//       </>
//     );
//   }
// }
// export default Dictation;


import React, { useState, useEffect, useRef } from "react";
import {Col , ProgressBar , Form,Button} from "react-bootstrap";
import { base, s3base } from "api.js";
import Sound from 'react-sound';
import "components/custom.css";
import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns";
import SelectVoiceDropDown from "components/PracticeMaterial/SelectVoiceDropDown.jsx";
import { formatTimeMiliSecond } from "util/helper.js";

const Dictation = (props) => {
  const [isRecording, setIsRecording] = useState(false);
  const [blobURL, setBlobURL] = useState('');
  const [isBlocked, setIsBlocked] = useState(false);
  const [question, setQuestion] = useState("");
  const [secondCount, setSecondCount] = useState(10);
  const [recordCount, setRecordCount] = useState(0);
  const [recordId, setRecordId] = useState(1);
  const [intervalId, setIntervalId] = useState(0);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [soundStatus, setSoundStatus] = useState(true);
  const [content, setContent] = useState('');
  const [soundPer, setSoundPer] = useState(0);
  const [volume, setVolume] = useState(100);
  const [correctFlag, setCorrectFlag] = useState(true);
  const [resultObj, setResultObj] = useState({});
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [soundKey, setSoundKey] = useState(0);
  const [questionAudio, setQuestionAudio] = useState(null);
  const [defaultSelectedVoice, setDefaultSelectedVoice] = useState(null);
  const [playStatus, setPlayStatus] = useState(Sound.status.STOPPED);
  const [remainingTime, setRemainingTime] = useState("00:00");
  const [audioRetryCount, setAudioRetryCount] = useState(0);
  const [audioFailed, setAudioFailed] = useState(false);
  const MAX_AUDIO_RETRIES = 1;

  const intervalIdRef = useRef(intervalId);
  const recordIdRef = useRef(recordId);
  const lastSoundPerRef = useRef(0);
  const lastSoundPerTimeRef = useRef(null);
  const stallWatchdogRef = useRef(null);
  const STALL_TIMEOUT_MS = 5000;

  // Update refs when state changes
  useEffect(() => {
    intervalIdRef.current = intervalId;
  }, [intervalId]);

  useEffect(() => {
    recordIdRef.current = recordId;
  }, [recordId]);

  // ComponentDidMount equivalent
  useEffect(() => {
    if (!props.answer) {
      // select audio.
      let question_audio = null;
      let defaultSelectedVoiceVal = null;
      if ('question_audios' in props.data && props.data.question_audios.length > 0) {
        let x = parseInt(Math.random() * 6);

        const { question_audios } = props.data;
        question_audio = `${s3base}/${question_audios[x].value}`;
        defaultSelectedVoiceVal = question_audios[x].label;
      } else {
        const { media_link } = props.data;
        question_audio = `${s3base}${media_link}`;
      }

      const newIntervalId = setInterval(timer, 1000);
      setIntervalId(newIntervalId);
      setQuestionAudio(question_audio);
      setDefaultSelectedVoice(defaultSelectedVoiceVal);
    }

    // Cleanup on unmount
    return () => {
      clearInterval(intervalIdRef.current);
    };
  }, []);

  // getDerivedStateFromProps equivalent
  useEffect(() => {
    if (props.data) {
      if ((questionId && questionId !== props.data.id) || props.restart) {
        clearInterval(intervalIdRef.current);
        clearInterval(recordIdRef.current);
        if (stallWatchdogRef.current) { clearInterval(stallWatchdogRef.current); stallWatchdogRef.current = null; }

        let question_audio = null;
        let defaultSelectedVoiceVal = null;
        if ('question_audios' in props.data && props.data.question_audios.length > 0) {
          let x = parseInt(Math.random() * 6);

          const { question_audios } = props.data;
          question_audio = `${s3base}/${question_audios[x].value}`;
          defaultSelectedVoiceVal = question_audios[x].label;
        } else {
          const { media_link } = props.data;
          question_audio = `${s3base}${media_link}`;
        }

        setCorrectFlag(true);
        setRecordCount(0);
        setSoundPer(0);
        setIsRecording(false);
        setSecondCount(10);
        setQuestionId(props.data.id);
        setBlobURL('');
        setReset(true);
        setSoundStatus(true);
        setContent('');
        setQuestionAudio(question_audio);
        setDefaultSelectedVoice(defaultSelectedVoiceVal);
        setAudioRetryCount(0);
        setAudioFailed(false);
        lastSoundPerRef.current = 0;
        lastSoundPerTimeRef.current = null;
      } else {
        if (!questionId) {
          setCorrectFlag(true);
          setQuestionId(props.data.id);
        }
      }
    }
  }, [props.data, props.restart, questionId]);

  useEffect(() => {
    if (soundStatus && secondCount === 0 && !audioFailed) {
      lastSoundPerRef.current = 0;
      lastSoundPerTimeRef.current = Date.now();
      stallWatchdogRef.current = setInterval(() => {
        const timeSinceProgress = Date.now() - (lastSoundPerTimeRef.current || Date.now());
        if (timeSinceProgress > STALL_TIMEOUT_MS && lastSoundPerRef.current > 0) {
          clearInterval(stallWatchdogRef.current);
          stallWatchdogRef.current = null;
          handleAudioError({ type: 'stall' });
        }
      }, 1000);
    }
    return () => { if (stallWatchdogRef.current) { clearInterval(stallWatchdogRef.current); stallWatchdogRef.current = null; } };
  }, [soundStatus, secondCount, audioFailed]);

  // Reset effect
  useEffect(() => {
    if (reset) {
      const newIntervalId = setInterval(timer, 1000);
      setIntervalId(newIntervalId);
      setReset(false);
    }
  }, [reset]);

  const timer = () => {
    setSecondCount((prevSecondCount) => {
      if (prevSecondCount <= 1) {
        clearInterval(intervalIdRef.current);
        setPlayStatus(Sound.status.PLAYING);
        return 0;
      } else {
        return prevSecondCount - 1;
      }
    });
  };

  const stopTest = () => {
    props.nextQuestion(resultObj);
  };

  const handleSongPlaying = (obj) => {
    const newPer = obj.position * 100 / obj.duration;
    // if (newPer > 10) return; // stop updating progress after 10%
    setSoundPer(newPer);
    setRemainingTime(formatTimeMiliSecond(obj.duration - obj.position));
    if (newPer !== lastSoundPerRef.current) {
      lastSoundPerRef.current = newPer;
      lastSoundPerTimeRef.current = Date.now();
    }
  };

  const changeRange = (e) => {
    setVolume(parseInt(e.target.value));
  };

  const handleSongFinishedPlaying = () => {
    if (stallWatchdogRef.current) { clearInterval(stallWatchdogRef.current); stallWatchdogRef.current = null; }
    console.log("stopped.");
    setSoundStatus(false);
    setPlayStatus(Sound.status.STOPPED);
    props.soundChecked();
    props.showResult();
  };

  const handleAudioError = (err) => {
    console.error('Audio playback error:', err);
    if (audioRetryCount < MAX_AUDIO_RETRIES) {
      setSoundStatus(false);
      setSoundPer(0);
      setAudioRetryCount(prev => prev + 1);
      setTimeout(() => { setSoundKey(prev => prev + 1); setSoundStatus(true); }, 300);
    } else {
      setAudioFailed(true);
      setSoundStatus(false);
      props.soundChecked();
    }
  };

  const copyToClipboard = () => {
    document.execCommand("copy");
  };

  const cutToClipboard = () => {
    document.execCommand("cut");
  };

  const pasteToClipboard = async () => {
    alert("Press Ctrl+v for paste text");
  };

  const changePlaybackSpeed = (speed) => {
    setSoundKey((prevSoundKey) => prevSoundKey + 1);
    setPlaybackSpeed(speed);
  };

  const chaneText = (e) => {
    let { name, value } = e.target;
    props.submit({ 'answer': value, 'correct': '' }, true);
    setContent(value);
    setResultObj({ 'answer': value, 'correct': '' });
  };

  const updateCorrect = () => {
    props.submit({ 'answer': '', 'correct': '' });
    setCorrectFlag(false);
    setResultObj({ 'answer': '', 'correct': '' });
  };

  const timerRecord = () => {
    setRecordCount((prevRecordCount) => {
      if (prevRecordCount === 40) {
        clearInterval(recordIdRef.current);
        stop();
      }
      return prevRecordCount + 1;
    });
  };

  const skip = () => {
    clearInterval(intervalIdRef.current);
    setSecondCount(0);
    setPlayStatus(Sound.status.PLAYING);
  };

  const changeAudio = (selected) => {
    const { question_audios } = props.data;
    const selected_audio = question_audios.filter((audio, i) => {
      return audio.label === selected.label;
    });

    setQuestionAudio(`${s3base}/${selected_audio[0].value}`);
    setPlayStatus(Sound.status.PLAYING);
  };

  const onLoad = (obj) => {
    // console.log(obj)
  };

  // Handle stopRecording
  useEffect(() => {
    if (props.stopRecording) {
      stopTest();
    }
  }, [props.stopRecording]);

  let questionText = "";
  if (props.restart) {
    props.restartQue();
  }
  if (props.data) {
    questionText = props.data.question;
    if (correctFlag) {
      updateCorrect();
    }
  }

  return (
    <>
      <Col xs={12}>
        <h4 className="infoText"></h4>
        {props.data &&
          !props.resultMode &&
          soundStatus &&
          secondCount === 0 && (
            <Sound
              autoLoad={true}
              url={questionAudio}
              playStatus={playStatus}
              onPlaying={handleSongPlaying}
              volume={volume}
              onFinishedPlaying={handleSongFinishedPlaying}
              onError={handleAudioError}
              playbackRate={playbackSpeed}
              key={soundKey}
              onLoading={onLoad}
            />
          )}
      </Col>

      {!props.resultMode && (
        <Col xs={12}>
          <div className="col-lg-12 text-center">
            <div className="currentStatus d-flex justify-content-center align-items-center p-0 audio-player-section">
              <div className="w-100 text-white p-4">
                {/* Current Status:{soundStatus == true && secondCount !== 0 && !isRecording && ' Begining in ' + secondCount + ' seconds'}
                {secondCount == 0 && soundStatus && ' Playing'}
                <br></br>
                Volume
                <Input
                  placeholder="Volume"
                  type="range"
                  defaultValue={volume}
                  step={1}
                  onInput={(e) => changeRange(e)}
                  min={0}
                  max={100}
                />
                <br></br>              
                <Progress color="info" value={(soundPer)} /> */}

                <div
                  className="d-flex justify-content-end w-100 align-items-center"
                  style={{ minHeight: "20px" }}
                >
                  {secondCount === 0 && blobURL === "" && !isRecording && (
                    <p className="mb-0 fs-10">{remainingTime}</p>
                  )}
                </div>
                <div className="d-flex justify-content-center align-content-center w-100 gap-3 py-1">
                  <i className="fa fa-play" aria-hidden="true"></i>
                  <div className="flex-grow-1">
                    <ProgressBar
                      style={{ backgroundColor: "#e9ecef", height: "15px" }}
                      barStyle={{ backgroundColor: "#4493e0" }}
                      now={soundPer}
                    />
                  </div>
                </div>
                <div
                  className="d-flex justify-content-start w-100 align-items-center"
                  style={{ minHeight: "20px" }}
                >
                  {soundPer === 100 ? (
                    <p className="mb-0 fs-10 mx-4">Completed</p>
                  ) : soundStatus === true &&
                    secondCount !== 0 &&
                    !isRecording ? (
                    <p className="mb-0 fs-10 mx-4">
                      The clip will begin in {secondCount} seconds
                    </p>
                  ) : (
                    <p className="mb-0 fs-10 mx-4 invisible"></p>
                  )}
                </div>
                <br></br>
                <div className="w-100 d-flex justify-content-center align-items-center">
                  <div className="d-flex justify-content-center gap-3  align-items-center w-50">
                    <i className="fa fa-volume-up" aria-hidden="true"></i>
                    <Form.Control
                      placeholder="Volume"
                      type="range"
                      min="0"
                      defaultValue={volume}
                      step="1"
                      onInput={(e) => changeRange(e)}
                      max="100"
                    />
                  </div>
                </div>

                {!props.testMode && (
                  <div className="d-flex justify-content-between">
                    <div className="stop-btn">
                      {secondCount !== 0 && blobURL === "" && !isRecording && (
                        <Button variant="success" onClick={skip} size="sm">
                          Skip
                        </Button>
                      )}
                    </div>

                    <div className="stop-btn clearfix">
                      <div className="select-voice pull-left">
                        {defaultSelectedVoice !== null && (
                          <SelectVoiceDropDown
                            voices={props.voices}
                            selected={defaultSelectedVoice}
                            changeAudio={changeAudio}
                          />
                        )}
                      </div>
                      <div className="select-speed pull-right">
                        <PlaybackSpeedBtns
                          changePlaybackSpeed={changePlaybackSpeed}
                          playbackSpeed={playbackSpeed}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <Col xs={12}></Col>

            <Col xs={12}>
              {blobURL && <audio src={blobURL} controls="controls" />}
            </Col>
          </div>
        </Col>
      )}

      <Col xs={12}>
        <h5>{questionText}</h5>
      </Col>

      {!props.resultMode && (
        <Col xs={12}>
            <div className="bottomContent test-editor-blue">
              <div className="copyPaste d-flex gap-2 mx-1 py-1">
                <a href="javascript:void(0)" onClick={cutToClipboard} className="btn">Cut</a>
                <a href="javascript:void(0)" onClick={copyToClipboard} className="btn">Copy</a>
                <a href="javascript:void(0)" onClick={pasteToClipboard} className="btn">Paste</a>
              </div>
            </div>          
          <Form.Group id="formGroupDiv">
            <Form.Control
              as="textarea"
              name="content"
              autoCorrect="false"
              spellCheck="false"
              id="textBox"
              onChange={(e) => {
                chaneText(e);
              }}
              value={content}
            />
          </Form.Group>
            <div className="bottomContent test-editor-blue">
              <div className="copyPaste">
                <p className="wordCount text-white text-start p-2">Word Count: {content.split(" ").filter(function (n) {
                  return n != "";
                }).length}</p>
              </div>
            </div>
          {/* <div className="bottomContent">
            <p className="wordCount">
              Total word count:{" "}
              {
                content.split(" ").filter(function (n) {
                  return n != "";
                }).length
              }
            </p>
            <div className="copyPaste">
              <a
                href="javascript:void(0)"
                onClick={cutToClipboard}
                className="btn"
              >
                Cut
              </a>
              <a
                href="javascript:void(0)"
                onClick={copyToClipboard}
                className="btn"
              >
                Copy
              </a>
              <a
                href="javascript:void(0)"
                onClick={pasteToClipboard}
                className="btn"
              >
                Paste
              </a>
            </div>
          </div> */}
        </Col>
      )}

      <Col xs={12}>
        <h5 className={props.resultMode ? "reading-text text-start":"question"}>{props.data && props.answer && props.data.audio_script}</h5>
      </Col>
    </>
  );
};

export default Dictation;